import type { CreateUserInput } from "../../../../../api-requests/users";
import type { User } from "../../../../../helpers/format-users";
import type { ModalDialogProps } from "../../../../shared/global-tools/dialog-system";
import { UserForm } from "../UserForm/UserForm";

export interface EditFieldDialogProps extends ModalDialogProps<void> {
  closeDialog: () => void;
  parameter: EditUserDialogParameter;
}

export interface EditUserDialogParameter {
  userToEdit: User;
  edit(inputs: CreateUserInput): Promise<void>;
  refreshUsers(): void;
}

export default function makeEditUserDialog({
  closeDialog,
  parameter: { userToEdit, edit, refreshUsers },
}: EditFieldDialogProps) {
  const content = (
    <UserForm
      action="edit"
      refreshUsers={refreshUsers}
      save={edit}
      successMessage="Utilisateur mis à jour"
      errorMessage="Echec mise à jour utilisateur"
      userToEdit={userToEdit}
      onSave={closeDialog}
    />
  );

  return { header: "Editer l'utilisateur", content };
}
